<script>
import LoginCarousel from "./Login-Carousel.vue";
import DevLoginDialog from "@/components/security/DevLoginDialog.vue";
export default {
  name: "LoginCards",
  data: () => ({
    startedLogin: false
  }),
  methods: {
    getSsoLoginUrl() {
      return !this.disableLoginButton
        ? this.$store.getters["user/ssoLoginUrl"]
        : "#";
    }
  },
  computed: {
    disableLoginButton() {
      return this.$store.getters["user/showDevLoginDialog"];
    }
  },
  components: { LoginCarousel, DevLoginDialog }
};
</script>
<template>
  <div>
    <v-row justify="center" no-gutters>
      <v-col class="carousel" cols="12" md="6">
        <LoginCarousel />
      </v-col>
      <v-col cols="12" md="6" class="login-col">
        <v-card class="login-card">
          <v-img
            class="logo"
            src="@/assets/logo/NEW-KoPo-Logo-Primary.svg"
            width="auto"
            contain
          />
          <LoginCarousel class="carousel-mobile" />
          <div class="login-mobile">
            <h2>Herzlich Wilkommen!</h2>
            <p>
              Im NEW-Kommunalportal bündeln wir alle Informationen für die
              Zusammenarbeit zwischen der NEW und den Kommunen - gemeinsam
              entwickelt und stetig verbessert.
            </p>
            <p>
              Der Zugang richtet sich an kommunale mitarbeitende in unserem
              Versorgungsgebiet. <br />
              Viel Spaß beim Erkunden.
            </p>
            <div class="d-flex justify-center">
              <v-btn
                :disabled="disableLoginButton"
                id="main_login"
                color="primary"
                :href="getSsoLoginUrl()"
                class="login-btn px-10 mt-10 mb-14"
                @click="startedLogin = true"
                :loading="startedLogin"
                >Zur Anmeldung</v-btn
              >
            </div>
            <p class="mb-12">
              <b>Sie wünschen einen Zugang oder haben eine Frage?</b> Sie
              erreichen uns schnell und einfach via
              <a
                class="text-decoration-underline"
                href="mailto:kommunalportal@new.de"
                >kommunalportal@new.de</a
              >
            </p>
            <a class="impressum-link" href="https://www.new.de/impressum"
              >Impressum</a
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
    <dev-login-dialog />
  </div>
</template>

<style scoped>
@media (min-width: 960px) {
  .carousel,
  .login-col {
    flex: 0 0 480px;
    max-width: 480px;
    width: 480px;
  }
  .login-card {
    width: 100%;
    aspect-ratio: 3 / 4;
    padding: 16px;
    box-shadow: none;
    border-radius: 0 8px 8px 0 !important;
  }
  .logo {
    margin-bottom: 60px;
    margin-right: 44px;
  }

  .login-mobile {
    position: absolute;
    bottom: 0;
    margin-bottom: 16px;
    margin-right: 8px;
  }
}

h2 {
  letter-spacing: 0.23px;
  margin-bottom: 8px;
}
p {
  letter-spacing: 0.32px;
  margin-bottom: 8px;
}

.carousel-mobile {
  display: none;
}

@media (max-width: 959px) {
  .carousel {
    display: none;
  }
  .carousel-mobile {
    display: block;
    margin-bottom: 24px;
  }
  .login-mobile {
    padding: 16px;
    position: static;
    margin: 0;
  }
  .logo {
    margin-bottom: 16px;
    margin-left: 44px;
    margin-right: 44px;
  }
  .login-card {
    padding-top: 16px;
    height: 100%;
    margin-top: 0 !important;
  }
  .impressum-link {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
  .login-btn {
    display: flex;
    justify-content: center;
    width: fit-content;
  }
}
</style>
